import React from "react"


import { t } from "@lingui/macro"

import {
    AssignableUsers,
    Workflow
} from "models"
import { SbDialog } from "../../commons/sb-dialog"
import AssignComponent from "./assign-component"

interface OptionsType
{
    id: string,
    name: string
}

interface AssignWorkflowProp
{
    openDialog: boolean
    onClose: () => void
    onAssign: (workflowId: string, userId: string) => void
    data: Workflow
    users: AssignableUsers[]
}

interface AssignWorkflowState
{
    personSelected: string
}

export class AssignWorkflow extends React.Component<AssignWorkflowProp, AssignWorkflowState>
{
    constructor(props: AssignWorkflowProp)
    {
        super(props)
        this.state = {
            personSelected: ""
        }
    }

    private onClose = () => {
        this.setState(() => ({
            personSelected: ""
        }))
        this.props.onClose()
    }

    private assign = () => {
        if(this.state.personSelected){
            this.props.onAssign(this.props.data.id, this.state.personSelected)
        }
    }

    private setSelection = (id: string) => {
        this.setState(() => ({
            personSelected: id
        }))
    }

    render()
    {
        return (
            <>
                {
                    this.props.openDialog &&
                    <SbDialog onClose={this.onClose}
                              width={"md"}
                              titleText={t({id: "workflow.assign-workflow.title", message: "Assegna workflow"})}
                              confirmButton
                              onConfirm={this.assign}
                    >
                        <AssignComponent data={this.props.data} users={this.props.users} selectionCallback={this.setSelection}/>
                    </SbDialog>
                }
            </>
        )
    }
}
